import {COMMON_SET_SNACK} from "~/store/mutations.type";
import ApiService from "~/common/service.api";
import {getErrorMsg} from "~/common/helper.string";
import {
    TICKET_GET_LIST,
    TICKET_GET_DETAIL,
    TICKET_POST_CREATE,
    TICKET_POST_REPLY,
    TICKET_POST_UPDATE_STATUS
} from "../actions.type";

const state = {
    ticket : {}
};

// getters
const getters = {
    ticket: state => state.ticket
};

// actions
const actions = {
    [TICKET_GET_LIST]({ commit }, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("tickets/get-list", params)
                .then(resp => {
                    if( resp.data.success) {
                        resolve(resp.data.data);
                        resolve(true);
                    }else{
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch(err => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },
    [TICKET_GET_DETAIL]({ commit }, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("tickets/get-detail", params)
                .then(resp => {
                    if( resp.data.success) {
                        resolve(resp.data.data);
                    }else{
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch(err => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },
    [TICKET_POST_CREATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post('tickets/create', params)
            .then(res => {
                if (res.data.success) {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "success"
                    });
                    resolve(res.data.data);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
                resolve(false);
            });
        });
    },
    [TICKET_POST_REPLY]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post('tickets/reply', params)
            .then(res => {
                if (res.data.success) {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "success"
                    });
                    resolve(res.data.data);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
                resolve(false);
            });
        });
    },
    [TICKET_POST_UPDATE_STATUS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post('tickets/update-status', params)
            .then(res => {
                if (res.data.success) {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "success"
                    });
                    resolve(res.data.data);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: res.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch(err => {
                commit(COMMON_SET_SNACK, {
                    message: err.response.data.message,
                    type: "error"
                });
                resolve(false);
            });
        });
    }
};

// mutations
const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
};
